<template>
	<div class="animated fadeIn">
		<div class="row pageinfo">
			<b-col lg="6">
				<!--Display Trash or Normal Table View-->
				<h2>Location - {{this.subTitle}}</h2>
			</b-col>
			<!--Gear Icon-->
			<b-col lg="6">
				<!-- <b-btn class="pull-right" v-b-popover.hover.top="'Select Datapoints'" variant="info" @click="configTable = true"><i class="fa fa-cog"></i></b-btn> -->
				<b-dropdown v-show="role =='super_admin' || (view1 && location_type_name != 'Unload') || (role =='operations_manager' && model.energy_company_owned)" :disabled="edit" class="pull-right" right variant="info" no-caret>
					<template slot="button-content">
								<i class="fa fa-cog"></i>
					</template>
					<b-dropdown-item @click="editLocation">Edit</b-dropdown-item>
					<b-dropdown-item @click="deleteLocations">Delete</b-dropdown-item>
				<!--	<b-dropdown-item @click="assigndrivers">Assign All Drivers</b-dropdown-item> -->
				</b-dropdown>
			</b-col>
		</div>
		<div class="location-information">
	    	<b-card v-if="loadingData">
					<b-col cols="12" sm="12" md="12" lg="12">
						<p class="text-center">
								<i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
						</p>
					</b-col>
				</b-card>
				<div v-else>
					<b-card pills card v-model="tabIndex" v-if="found">
							<b-row>
								<b-col md="9">
									<b-form-group :label-cols="4" horizontal label="Id" label-for="id" >
										<b-form-input class="plaintext-input" plaintext id="id" v-model="model.id" type="text"></b-form-input>
									</b-form-group>
									<b-form-group v-if="role ==='super_admin'" :label-cols="4" id="L3" label="Is this location owned, operated, and solely used by your energy company?" label-for="CompanyTypeID" horizontal>
										<b-form-checkbox v-if="!edit"
                  							id="checkbox"
											class="custom-checkboxes"
                      						style="margin-top: 23px;"
											v-model="model.energy_company_owned"
											disabled
              							></b-form-checkbox>	
										<b-form-checkbox v-else
                  							id="checkbox"
											class="custom-checkboxes"
                      						style="margin-top: 23px;"
											v-model="model.energy_company_owned"
              							></b-form-checkbox>	
									</b-form-group>
									<b-form-group v-else :label-cols="4" id="L3" label="Is this location owned, operated, and solely used by your energy company?" label-for="CompanyTypeID" horizontal>
										<b-form-checkbox
                  							id="checkbox"
											class="custom-checkboxes"
                      						style="margin-top: 23px;"
											v-model="model.energy_company_owned"
											disabled
              							></b-form-checkbox>	
									</b-form-group>


									<b-form-group v-show="role =='super_admin'" v-if="model.energy_company_owned" :label-cols="4" id="L4" label="Energy Company" label-for="EnergyCompanyID" horizontal>
										<b-form-input class="plaintext-input" v-show="!edit" plaintext id="EnergyCompanyID" v-model="model.energy_company" type="text"></b-form-input>
										<b-form-select v-show="edit" id="EnergyCompanyID" v-model="model.energy_company_id" :options="energycompanyselect" @input="select_energy_company()" />
									</b-form-group>
									<b-form-group label="Location Type" label-for="LocationTypeID" :label-cols="4" horizontal>
										<b-form-input class="plaintext-input" v-show="!edit" plaintext id="LocationTypeID" v-model="model.location_type" type="text"></b-form-input>
										<b-form-select v-if="role ==='super_admin' || role ==='operations_manager'" v-show="edit" id="LocationTypeID" v-model="model.location_types_id" :options="locationselect" placeholder="Select Location Type"  @input="select_location_type()"/>
										<b-form-select v-else v-show="edit" id="LocationTypeID" v-model="model.location_types_id" :options="locationselect" placeholder="Select Location Type"  disabled/>
									</b-form-group>

									<b-form-group v-if="fluidtypeselect.length > 0 && edit" :label-cols="4" id="L4" label="Fluid Type" label-for="FluidTypeID" horizontal>
										<b-form-checkbox-group class="custom-checkboxes" :options="fluidtypeselect" name="Checkboxes" plain v-model="model.fluid_type_id" @input="fluidTypeChange"></b-form-checkbox-group>
										<b-form-checkbox style="margin-top: 15px;" v-model="fluidAllSelected" :indeterminate="indeterminate" aria-describedby="" aria-controls="" plain @change="fluidToggleAll">
											{{ fluidAllSelected ? 'Un-select All' : 'Select All' }}
										</b-form-checkbox>
									</b-form-group>

									<b-form-group v-if="model.fluid_types.length > 0 && !edit" :label-cols="4" id="L4" label="Fluid Type" label-for="FluidTypeID" horizontal>
										<b-form-checkbox-group text-field="name" class="custom-checkboxes" :options="model.fluid_types" name="Checkboxes" plain :checked="allChecked()" disabled></b-form-checkbox-group>
									</b-form-group>

									<b-form-group v-if="location_type_name == 'Load'" :label-cols="4" id="L4" label="Battery Code" label-for="BatteryCodeID" horizontal>
										<b-form-input class="plaintext-input" v-show="!edit" plaintext id="BatteryCodeID" v-model="model.battery_code" type="text"></b-form-input>
										<b-form-input v-show="edit" id="BatteryCodeID" v-model="model.battery_code"  />
									</b-form-group>
									<!-- Terminal -->

									<b-form-group v-if="location_type_name == 'Unload'" :label-cols="4" id="L14" label="Terminal" label-for="TerminalID" horizontal>
										<b-form-select v-if="edit" value-field="id" text-field="name" id="TerminalID" v-model="model.terminal_id" :options="terminalselect">
										 <template slot="first"><option :value="null">-- select terminal --</option></template>
										</b-form-select>
										<b-form-input v-else class="plaintext-input" id="TerminalID" v-model="model.terminal" type="text" plaintext></b-form-input>
									</b-form-group>
									<b-form-group v-if="location_type_name == 'Unload'" :label-cols="4" id="L4" label="Terminal Code" label-for="TerminalCodeID" horizontal>
										<b-form-input class="plaintext-input" v-show="!edit" plaintext id="TerminalCodeID" v-model="model.terminal_code" type="text"></b-form-input>
										<b-form-input v-show="edit" id="TerminalCodeID" v-model="model.terminal_code"  />
									</b-form-group>

									<b-form-group label="Location Name" label-for="locationname" :label-cols="4" horizontal>
										<b-form-input class="plaintext-input" v-show="!edit" plaintext id="locationname" v-model="model.legal_location" type="text"></b-form-input>
										<b-form-input v-show="edit" id="locationname" v-model="model.legal_location" type="text"></b-form-input>
									</b-form-group>
									<b-form-group label="Location Isolera Name" label-for="isolera_location_name" :label-cols="4" horizontal>
										<b-form-input class="plaintext-input" v-show="!edit" plaintext id="isolera_location_name" v-model="model.isolera_location_name" type="text"></b-form-input>
										<b-form-input v-show="edit" id="isolera_location_name" v-model="model.isolera_location_name" type="text"></b-form-input>
									</b-form-group>
									<b-form-group label="Longitude" label-for="longitude" :label-cols="4" horizontal>
										<b-form-input class="plaintext-input" v-show="!edit" plaintext id="longitude" v-model="model.longitude" type="text"></b-form-input>
										<b-form-input v-show="edit" id="longitude" v-model="model.longitude" @blur.native="coordsBlur('longitude')" type="number"></b-form-input>
									</b-form-group>
									<b-form-group label="Latitude" label-for="latitude" :label-cols="4" horizontal>
										<b-form-input class="plaintext-input" v-show="!edit" plaintext id="latitude" v-model="model.latitude" type="text"></b-form-input>
										<b-form-input v-show="edit" id="latitude" v-model="model.latitude" @blur.native="coordsBlur('latitude')" type="number"></b-form-input>
									</b-form-group>

									<b-form-group label="LSD" label-for="lsd" :label-cols="4" horizontal>
										<b-form-input class="plaintext-input" v-show="!edit" plaintext id="lsd" v-model="model.lsd" type="text"></b-form-input>
										<b-form-input v-show="edit" id="lsd" v-model="model.lsd" type="text"></b-form-input>
									</b-form-group>

									<b-form-group v-if="location_type_name =='Load'" label="Invoice Code" label-for="invoice_code" :label-cols="4" horizontal>
										<b-form-input class="plaintext-input" v-show="!edit" plaintext id="invoice_code" v-model="model.invoice_code" type="text"></b-form-input>
										<b-form-input v-show="edit" id="invoice_code" v-model="model.invoice_code" type="text"></b-form-input>
									</b-form-group>
									<!-- UWI -->
									<b-form-group v-if="location_type_name == 'Load'" :label-cols="4" id="L8" label="Uwi" label-for="uwi" horizontal>
									<!--	<b-btn v-if="edit" v-on:click="adduwi()" size="sm" variant="primary" class="pull-left">Add Uwi</b-btn>-->
									<b-card v-if="location_type_name == 'Load'" title="" class="p-0 m-0 mb-3">
										<b-table striped show-empty empty-text="No UWI have been added"
											:fields = "[{key: 'delete', label: ' '}, {key: 'name', label: 'UWI Name'}, {key: 'cost_code', label: 'Cost Code'}, {key: 'percentage', label: 'Percentage'}]" 
											:items="model.uwi" stacked="sm" outlined small>
											<template v-if="edit" slot="delete" slot-scope="item">
												<b-btn v-b-tooltip.hover title="Delete" v-on:click="removeuwi(item.index)" size="sm" class="pull-right"><i class="icon-close"></i></b-btn>
											</template>
											<template slot="name" slot-scope="item">
												<b-form-input v-if="edit" size="sm" id="name" v-model="model.uwi[item.index].name" /> 
												<span v-else>{{model.uwi[item.index].name}}</span>
											</template>
											<template slot="cost_code" slot-scope="item">
												<b-form-input v-if="edit" size="sm" id="cost_code" v-model="model.uwi[item.index].cost_code" type="text" />
												<span v-else>{{model.uwi[item.index].cost_code}}</span>
											</template>
											<template  slot="percentage" slot-scope="item">
												<b-form-input v-if="edit" size="sm" id="percentage" v-model="model.uwi[item.index].percentage" type="text" @keydown.native="myOnlyNumber($event, 'percentage')"/>
												<span v-else>{{model.uwi[item.index].percentage}}</span>
											</template>
										</b-table>
										<b-row v-if="edit">
											<b-col sm="12">
												<b-btn  v-on:click="adduwi()" size="sm" variant="primary" class="pull-right">Add Uwi</b-btn>
											</b-col> 
										</b-row> 
									</b-card>
									</b-form-group>
									<!-- UWI -->

									<b-form-group v-if="location_type_name =='Load'" label="Contact Name" label-for="contact_name" :label-cols="4" horizontal>
										<b-form-input class="plaintext-input" v-show="!edit" plaintext id="contact_name" v-model="model.contact_name" type="text"></b-form-input>
										<b-form-input v-show="edit" id="invoice_code" v-model="model.contact_name" type="text"></b-form-input>
									</b-form-group>

									<b-form-group v-if="operationareaselect.length > 0 && edit" :label-cols="4" id="L5" label="Operating Areas" label-for="operationAreasID" horizontal>
										<b-form-checkbox-group class="custom-checkboxes" :options="operationareaselect" name="Checkboxes2" plain v-model="model.operation_area_id" @input="operationAreaChange"></b-form-checkbox-group>
										<b-form-checkbox style="margin-top: 15px;" v-model="oaAllSelected" :indeterminate="indeterminateOA" aria-describedby="" aria-controls="" plain @change="OAToggleAll">
											{{ oaAllSelected ? 'Un-select All' : 'Select All' }}
										</b-form-checkbox>
									</b-form-group>

									<b-form-group v-if="model.operating_areas.length > 0 && !edit" :label-cols="4" id="L6" label="Operating Areas" label-for="operationAreasID" horizontal>
										<b-form-checkbox-group text-field="name" class="custom-checkboxes" :options="model.operating_areas" name="Checkboxes2" plain :checked="allCheckedOA()" disabled></b-form-checkbox-group>
									</b-form-group>
									<b-form-group v-if="agreements.length > 0 && edit && model.energy_company_owned" :label-cols="4" id="L7" label="Agreements" label-for="operationAreasID" horizontal>
										<b-form-checkbox-group class="custom-checkboxes" :options="agreements" name="Checkboxes2" plain v-model="model.agreement_id" @input="agreeChange"></b-form-checkbox-group>
										<b-form-checkbox style="margin-top: 15px;" v-model="agreeAllSelected" :indeterminate="indeterminateAgree" aria-describedby="" aria-controls="" plain @change="agreeToggleAll">
											{{ agreeAllSelected ? 'Un-select All' : 'Select All' }}
										</b-form-checkbox>
									</b-form-group>
									<b-form-group v-if="model.agreements.length > 0 && !edit && model.energy_company_owned" :label-cols="4" id="L8" label="Agreements" label-for="agreeID" horizontal>
										<b-form-checkbox-group text-field="name" class="custom-checkboxes" :options="model.agreements" name="Checkboxes2" plain :checked="allCheckedAgree()" disabled></b-form-checkbox-group>
									</b-form-group>
									<div>
										<b-form-group v-if="!edit" :label-cols="4" horizontal label="Petrotranz Location" label-for="ptty">																  
											<b-form-input   v-if="model.petrotranz!=null" class="plaintext-input"  plaintext id="ptty" v-model="model.petrotranz.name" type="text"></b-form-input>		
										</b-form-group>
										<b-form-group  v-else :label-cols="3" horizontal label="Petrotranz Location" label-for="ptty1">
											<b-form-input autocomplete="off" class="plaintext-input"  id="ptty1" @keydown.native=keyMonitor($event) v-model="filtered" placeholder="Search Filtered starting by ... (minimum 3 char)" type="text"></b-form-input>
											<b-form-select v-show='suggest' :select-size=size :disabled="petrotranz.length==0" value-field="id" text-field="name" id="ptty1" v-model="model1.petrotranz_company_id" :options="petrotranz"  @input="select_petrotranz()"/>							
											<div v-show='ready'>
												<i class="fa fa-refresh fa-lg mt-4 fa-spin"></i>
											</div>
										</b-form-group>

									</div>
									<div v-if="edit" slot="footer">
										<b-button @click="updateLocation(model)" size="sm" variant="primary"><i class="fa fa-edit"></i> Update</b-button>
										<b-button  @click="editLocation" size="sm" ><i class="fa fa-ban"></i> Cancel</b-button>
									</div>

							</b-col>
						</b-row>
				</b-card>
				<b-row v-else>
					<b-col cols="12" sm="12" md="12" lg="12">
						<br>
							<p class="text-center text-danger">
								<i class="icon fa-lg icon-puzzle"></i><br>{{notFoundMessage}}
							</p>
					</b-col>
				</b-row>
			</div>
		</div>
	</div>
</template>

<script>
	// ********** imports ************ //
	import Vue from 'vue'
	import vSelect from 'vue-select'
	import axios from 'axios'
	import {
		apiDomain
	} from '../../config'
	import locations_service from './locations_service'
	import target_service from '../m_targets/targets'

	Vue.component('v-select', vSelect)

	const items = []
	export default {
		name: 'm_location',
		props: {
			id: {
				type: String,
				default: 0
			}
		},
		created: function() {
			if (localStorage.getItem('role') == "super_analyst") {
				this.isSuperAnalyst = true
			}
			this.getLocationData()
		},
		data() {
			return {
				isSuperAnalyst: false,
				indeterminateOA: false,
				indeterminate: false,
				oaAllSelected: false,
				fluidAllSelected: false,
				location_type_name: '',

				locationselect: [],
				energycompanyselect: [],
				fluidtypeselect: [],
				operationareaselect: [],
				terminalselect: [],


				operatingAreasfields: {
					operating_area: {
						label: 'Operating Area Name'
					}
				},
				fluidTypesfields: {
					fluid_type: {
						label: 'Fluid Type Name'
					}
				},
				originalData: null,
				edit: false,
				subTitle: "",
				loadingData: true,
				tabIndex: 0,
				found: false,
				notFoundMessage: 'Not found',
				item: [],

				model: {
					id						: null,
					legal_location			: '',
					isolera_location_name	: '',
					longitude				: null,
					latitude				: null,
					location_types_id		: '',
					fluid_type_id			: [],
					energy_company_id		: '',     // if energy_company_owned value is true
					energy_company			: '',     // if energy_company_owned value is true
					operation_area_id		: [],
					lsd						: '',
					energy_company_owned 	: false,
					battery_code			: '',     // load
					terminal_id				: null,   // unload
					terminal     			: '',
					terminal_code			: '',     // unload
					invoice_code			:'',      // load
					uwi						:[],      // load
					contact_name 			:'',       // load
					agreement_id     		: [],       // load and unload
					petrotranz          	: null,    // petrotranz location
					filter              	: '',		// petrotranz location
				},
				filtered            : '',
				items				: items,
				options				: [],
				fluids				: [],
				operatingAreasItems	: [],
				fluidTypesItems		: [],
				role				:'',
				view				:true,
				view1				:true,
				percentage			:'',
				agreements			: [],
				indeterminateAgree	: false,
				agreeAllSelected	: false,
				// petrotranz
				petrotranz 			: [],
				petrotranz_origin 	: [],
				model1 : {
					petrotranz_company_id: {id:null,name:''},
				},
				size                : 6,
				offset              : '',
				ready               : false,
				suggest             : true,
			}
		},
		watch: {
			filtered: function(val, oldVal) {
				this.petrotranz = []
				this.model.filter = val
				this.filter_p(this.model.filter)
			}
    	},
		methods: {
			coordsBlur(variableName) {
				if(this.model[variableName] !== undefined) {
					let x = String(this.model[variableName]).split(".")
					if(x.length == 1 && x[0].length == 0) {
						this.model[variableName] = '0.00'
					} else if(x.length == 1) {
						this.model[variableName] = this.model[variableName] + '.00'
					} else {
						this.model[variableName] = x[0] + "." + x[1]
						this.model[variableName] = parseFloat(parseFloat(String(this.model[variableName])))
					}
				}
			},
			allChecked() {
				return Array(this.model.fluid_types.length).fill(true)
			},
			allCheckedOA() {
				return Array(this.model.operating_areas.length).fill(true)
			},
			fluidToggleAll(checked) {
				this.model.fluid_type_id = checked ? this.fluidtypeselect.map(item => {
					return item.value
				}) : []
			},
			OAToggleAll(checked) {
				this.model.operation_area_id = checked ? this.operationareaselect.map(item => {
					return item.value
				}) : []
			},
			fluidTypeChange() {
				if (this.model.fluid_type_id.length === 0) {
					this.indeterminate = false
					this.fluidAllSelected = false
				} else if (this.model.fluid_type_id.length === this.fluidtypeselect.length) {
					this.indeterminate = false
					this.fluidAllSelected = true
				} else {
					this.indeterminate = true
					this.fluidAllSelected = false
				}
			},
			operationAreaChange() {
				if (this.model.operation_area_id.length === 0) {
					this.indeterminateOA = false
					this.oaAllSelected = false
				} else if (this.model.operation_area_id.length === this.operationareaselect.length) {
					this.indeterminateOA = false
					this.oaAllSelected = true
				} else {
					this.indeterminateOA = true
					this.oaAllSelected = false
				}
			},
			select_energy_company() {
				//let location_types = this.updateData.location_types
				//let current_location_type_index = location_types.map(o => o.id).indexOf(this.model.location_types_id)
				//if (current_location_type_index > -1) {

					let energycompanies = this.updateData['energy_companies']
					let energy_company_index = energycompanies.map(o => o.id).indexOf(this.model.energy_company_id)
					if (energy_company_index > -1) {
						this.model.energy_company =  energycompanies[energy_company_index].company_name
						let operatingareas = energycompanies[energy_company_index].operating_areas
						let agreements = energycompanies[energy_company_index].agreements
						if (Array.isArray(operatingareas)) {
							this.operationareaselect = operatingareas.map((item) => {
								return {
									'value': item.id,
									'text': item.name
								}
							})
							this.model.operation_area_id 	= []
							this.agreements 				= agreements
							this.model.agreement_id 		= []
						} else {
							this.operationareaselect = []
							this.model.operation_area_id = []
							this.indeterminateOA = false
							this.indeterminate = false
							this.oaAllSelected = false
							this.fluidAllSelected = false
							this.agreements 				= []
							this.model.agreement_id 		= []
							this.indeterminateAgree = false
							this.indeterminate = false
							this.agreeAllSelected = false
						}
					}
				//}
			},
			select_location_type() {
				//this.model.energy_company_id = ''
				//this.operationareaselect 	= []
				//this.indeterminateOA = false
				this.indeterminate = false
				//this.oaAllSelected = false
				this.fluidAllSelected = false

				let location_types = this.updateData.location_types

				let current_location_type_index = location_types.map(o => o.id).indexOf(this.model.location_types_id)
				if (current_location_type_index > -1) {
					this.location_type_name = location_types[current_location_type_index].name
					if (location_types[current_location_type_index].fluid_types) {
						let fluidtypes = location_types[current_location_type_index].fluid_types
						this.fluidtypeselect = fluidtypes.map((item) => {
							return {
								'value': item.id,
								'text': item.name
							}
						})

						if (this.model.fluid_types.length > 0) {
							this.model.fluid_type_id = this.model.fluid_types.map(item => {
								return item.id
							})
						}

					} else {
						this.fluidtypeselect = []
						this.model.fluid_type_id = []
					}
				}
			},
			editLocation() {
				if (this.edit) {
					this.edit = false
					this.restoreOriginalData()
				} else {
					this.setupFields()
					this.edit = true
				}
			},
			restoreOriginalData() {
				let model = {
					...this.originalData,
					fluid_type_id: [],
					operation_area_id: [],
					agreement_id: [],
					agreements: Array.isArray(this.originalData.agreements) ? this.originalData.agreements : [],
					fluid_types: Array.isArray(this.originalData.fluid_types) ? this.originalData.fluid_types : [],
					operating_areas: Array.isArray(this.originalData.operating_areas) ? this.originalData.operating_areas : []
				}
				this.location_type_name = model.location_type
				this.model = JSON.parse(JSON.stringify(model))
				this.indeterminateAgree	= false,
				this.agreeAllSelected	= false
				this.filtered = this.model.filter
			},
			setupFields() {
				// location type: Load - Unload
				let location_types = this.updateData['location_types']
				this.locationselect = location_types.map((item) => {
					return {
						'value': item.id,
						'text': item.name
					}
				})
				// -----------------------------
				// Energy company
				let energy_company = this.updateData['energy_companies']
				this.energycompanyselect = energy_company.map((item) => {
						return {
							'value': item.id,
							'text': item.company_name
							}
						})
				if (this.model.energy_company_owned) {
					let energy_company_index = energy_company.map(o => o.id).indexOf(this.model.energy_company_id)
					if (energy_company_index > -1) {
						let operating_areas = energy_company[energy_company_index]['operating_areas']						
						if (Array.isArray(operating_areas)) {
							this.operationareaselect = operating_areas.map((item) => {
								return {
									'value': item.id,
									'text': item.name
								}
							})

							if (this.model.operating_areas.length > 0) {
									this.model.operation_area_id = this.model.operating_areas.map(item => {
										return item.id
								})
							}

						} else {
							this.operationareaselect = []
							this.model.operating_areas_id = []
						}
						let agreements = energy_company[energy_company_index].agreements
						if (Array.isArray(agreements)) {
							this.agreements = agreements
							if (this.model.agreements.length > 0) {
								this.model.agreement_id = this.model.agreements.map(item => {
										return item.id
								})
							}
						} else {
							this.agreements 		= []
							this.model.agreement_id = []
						}
					}
				} else {
						let operatingareas = this.updateData['operating_areas']
						if (Array.isArray(operatingareas)) {
							this.operationareaselect = operatingareas.map((item) => {
								return {
									'value': item.id,
									'text': item.name
								}
							})
							this.model.operation_area_id = this.model.operating_areas.map(o => o.id)
						} else {
							this.operationareaselect = []
							this.model.operation_area_id = []
							this.indeterminateOA = false
							this.indeterminate = false
							this.oaAllSelected = false
							this.fluidAllSelected = false
						}
						this.agreements 		= []
						this.model.agreement_id = []
				}
				// --------------------------------------
				let location_types_index = location_types.map(o => o.id).indexOf(this.model.location_types_id)
				if (location_types_index > -1) {
					let fluid_types = location_types[location_types_index]['fluid_types']
					if(Array.isArray(fluid_types)) {
						this.fluidtypeselect = fluid_types.map((item) => {
							return {
								'value': item.id,
								'text': item.name
							}
						})
					} else {
						this.fluidtypeselect = []
					}

					if (this.model.fluid_types.length > 0) {
						this.model.fluid_type_id = this.model.fluid_types.map(item => {
							return item.id
						})
					}
/*
					if(this.location_type_name.toLowerCase() === 'unloads' || this.location_type_name.toLowerCase() === 'unload') {
						let energy_company_index = energy_company.map(o => o.id).indexOf(0)


					} else {
						//

						//
					} */

				}
				this.petrotranz = this.petrotranz_origin
				this.size       = 6
				this.ready      = false
				this.suggest    = true
			},
			getLocationData() {
				locations_service.getBy(this.id)
					.then(data => {
						if (data[0] == 'success') {
							this.originalData = data[1]
							this.updateData = data[2]
							this.restoreOriginalData()
							this.terminalselect = this.updateData.terminals
							this.subTitle = this.originalData.legal_location
							this.found = true
							this.loadingData = false
							this.petrotranz = this.updateData.petrotranz
							this.petrotranz_origin = this.updateData.petrotranz
							this.role = data[3]
							if (this.role =='super_admin') {
								this.view=true
								this.view1=true
							} else if (this.role =='super_analyst') {
								this.view=false
								this.view1=true
								this.energy_company_id = data[4]
							} else if (this.role =='analyst' || this.role =='marketing_accountant') {
								this.view=false
								this.view1=false
							} else if (this.role =='trucking_company_admin' || this.role =='trucking_operational_manager') {
								this.view1=false
							} else if  (this.role =='operations_manager') {
								this.view1=false
							}
								
						} else {
							this.loadingData = false
							this.$swal(data[0], data[1], data[0])
						}
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
						this.loadingData = false
					})
			},
			okToUpdate() {
				if (this.model.location_types_id === undefined || this.model.location_types_id.length == 0) {
					this.$swal('Alert!', 'Location Type not selected', 'warning')
					return false
				} else if (this.model.legal_location === undefined || this.model.legal_location.length == 0) {
					this.$swal('Alert!', 'Location Name can not be empty', 'warning')
					return false
				} else if (this.model.longitude === null || String(this.model.longitude).length == 0) {
					this.$swal('Alert!', 'Longitude can not be empty', 'warning')
					return false
				} else if (this.model.latitude === null || String(this.model.latitude).length == 0) {
					this.$swal('Alert!', 'Latitude can not be empty', 'warning')
					return false
				}
				if (this.model.location_types_id === 1) {
					if (this.model.invoice_code === undefined || this.model.invoice_code === null) {
						this.$swal('Alert!', 'Invoice Code  Required', 'warning')
						return false
					} else 	if (this.model.contact_name === undefined || this.model.contact_name === null) {
						this.$swal('Alert!', 'Contact Name  Required', 'warning')
						return false
					}	

					if(this.model.uwi.length>0){
						let length = this.model.uwi.length;
						for (var i = 0; i < length; i++) {
							if(this.model.uwi[i].name == null || this.model.uwi[i].name == '') {
								this.$swal('Alert!', 'Uwi name cannot be empty', 'warning')
								return false
							} else if(this.model.uwi[i].cost_code	== null || this.model.uwi[i].cost_code	== '') {
								this.$swal('Alert!', 'Uwi Cost Code cannot be empty', 'warning')
								return false
							} else if(this.model.uwi[i].percentage	== null || this.model.uwi[i].percentage	== '') {
								this.$swal('Alert!', 'Uwi Percentage cannot be empty', 'warning')
								return false 
							}			
						} 
					} 	
				}
				//
				if (this.model.energy_company_owned) {
					if ((this.model.energy_company_id === undefined || this.model.energy_company_id.length == 0) && (this.location_type_name.toLowerCase() == 'loads' || this.location_type_name.toLowerCase() == 'load')) {
						this.$swal('Alert!', 'Energy Company not selected', 'warning')
						return false
					} 
				}
				//
				return true
			},
			updateLocation(model) {
				if (this.role =='super_analyst'){
					this.model.energy_company_id = this.energy_company_id
				}
				if (!this.okToUpdate()) {
					return
				}
				
				model = {
					legal_location			: model.legal_location,
					isolera_location_name	: model.isolera_location_name,
					energy_company_owned 	: model.energy_company_owned, 
					energy_company_id		: model.energy_company_id,
					energy_company			: model.energy_company,
					longitude				: parseFloat(parseFloat(String(model.longitude))),
					latitude				: parseFloat(parseFloat(String(model.latitude))),
					location_types_id		: model.location_types_id,
					fluid_types				: model.fluid_type_id.map(item => {
						return {
							id: String(item)
						}
					}),
					operating_areas			: model.operation_area_id.map(item => {
						return {
							id: String(item)
						}
					}),
					lsd						: model.lsd,
					battery_code			: model.battery_code,
					terminal_id  			: model.terminal_id,
					terminal_code			: model.terminal_code,
					invoice_code			:model.invoice_code,
					uwi						:model.uwi,
					contact_name 			:model.contact_name,
					agreements	     		: model.agreement_id.map(item => {
						return {
							id: String(item)
						}
					}),
					petrotranz : this.model1.petrotranz_company_id,
				}
				this.model.id = this.id
				locations_service.update(this.id, model)
					.then((data) => {
						this.$swal(data[0], data[1], data[0])
						if (data[0] == 'success') {
							this.getLocationData()
							this.edit = false
						}
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
						this.edit = false
					})
					
			},
			deleteLocations() {
				this.$swal({
					title: 'Please, confirm',
					text: "Are you sure to delete this Location: " + this.subTitle + " ?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
					reverseButtons: true
				}).then((result) => {
					if (result.value) {
						locations_service.delete(this.id)
							.then(data => {
								this.$swal(data[0], data[1], data[0])
								if (data[0] == 'success') {
									this.filter = ''
									this.$router.push('/locations')
								}
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
							})
					}
				})
			},
			assigndrivers() {
				this.$swal({
					title: 'Please, confirm',
					text: "Are you sure to assign all drivers to this Location?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
					reverseButtons: true
				}).then((result) => {
					if (result.value) {
						locations_service.assigndrivers(this.id, this.model.operating_areas)
							.then(data => {
								this.$swal(data[0], data[1], data[0])
								if (data[0] == 'success') {
									this.getLocationData()
								}
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
							})
					}
				})
			},
			adduwi() {
					let uwi	= {
						name		: null,
						cost_code	: null,
						percentage	: null,
					}
					this.model.uwi.push(uwi)

			},
			removeuwi(uwi) {
					this.model.uwi.splice(uwi,1)
			},
			myOnlyNumber(evt, variableName) {
					let dotPosition = this[variableName].indexOf(".")
					let hasDot = dotPosition > -1
					let length = this[variableName].length
					this.isNumber(evt, hasDot, dotPosition, length)
			},
			isNumber: function(evt, hasDot, dotPosition, length) {
					evt = (evt) ? evt : window.event;
					var charCode = (evt.which) ? evt.which : evt.keyCode;
					if (charCode <= 31 || charCode == 37 || charCode == 39 || (charCode >= 96 && charCode <= 105) || ((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 19 || (!hasDot && charCode == 190)|| (!hasDot && charCode == 110))) {
					// if (charCode <= 31 || charCode == 37 || charCode == 39 || ((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 19 || (!hasDot && charCode == 190))) {
						let selectionStart = evt.target.selectionStart;
						let selectionEnd = evt.target.selectionEnd;
						if ((hasDot && selectionEnd > dotPosition && length - 2 > dotPosition) && charCode > 31 && (charCode != 37 && charCode != 39)) {
							evt.preventDefault();
						} else {
							return true
						}
					} else {
						evt.preventDefault();
					}
			},
			allCheckedAgree() {
				return Array(this.model.agreements.length).fill(true)
			},
			agreeToggleAll(checked) {
				this.model.agreement_id = checked ? this.agreements.map(item => {
					return item.value
				}) : []
			},
			agreeChange() {
				if (this.model.agreement_id.length === 0) {
					this.indeterminateAgree = false
					this.agreeAllSelected = false
				} else if (this.model.agreement_id.length === this.agreements.length) {
					this.indeterminateAgree = false
					this.agreeAllSelected = true
				} else {
					this.indeterminateAgree = true
					this.agreeAllSelected = false
				}
			},
			// Selecting when pressing Enter
			keyMonitor(evt) {
				if(evt.key.match(/[a-zA-Z0-9,/,-]/i)===null) {
						evt.preventDefault();
						return					
				} else {
					evt = (evt) ? evt : window.event;
					let key = evt.key
					this.offset = key
					this.suggest = true
					if (key == "NumLock" || key == "ScrollLock" || key == "Insert" || key == "Home" || key == "End" || key == "PageUp" || key == "PageDown" || key == "Shift" || key == "AltGraph" || key == "Control" || key == "Tab" || key == "CapsLock" || key == "Alt" || key == "Enter" || key == "ArrowLeft" || key == "ArrowRight" || key == "ArrowUp" || key == "ArrowDown")  {
						return
					} else if (key == "Backspace" ) {
						//this.petrotranz = []
						//let filter_txt = this.model.filter
						//let nn 				= filter_txt.length - 1
						//if (nn>0) {
						//	this.model.filter = filter_txt.substring(0, nn)
						//	this.filter_p(this.model.filter)
						//	return
						//} else {
						//	this.model.filter  = ''
							let splitter = this.filtered.split("(");
							this.filtered = splitter[0]
							this.model.filter= this.filtered
							this.petrotranz = []
							this.filter_p(this.model.filter)
							this.model1.petrotranz_company_id.id = null
							return
						//}
						
					} else if (key == "Delete" ) {
						return
					} else {
						//this.petrotranz = []
						//let filter_txt = this.model.filter
						//filter_txt = filter_txt + key
						//this.model.filter = filter_txt
						//this.filter_p(this.model.filter)	
						return					
					}
				}
			},
			select_petrotranz() {
				this.size 			= 1
				//let loc 			= this.model1.petrotranz_company_id.name
				//let loc_1 = loc.split("(")
				this.model.filter 	= this.model1.petrotranz_company_id.name
				this.filtered	    = this.model.filter
				//this.model1.petrotranz_company_id.name = loc_1[0]
				this.suggest 		= false
			},
			filter_p(check_filter) {
				this.size = 6
				if (this.model.filter!=='' && this.model.filter.length>0) {
					let filter = {filter:this.model.filter}
					this.ready = true
					locations_service.petrotranz(filter)
							.then(data => {
								if (data.status == 'success') {
									if (this.model.filter==check_filter) {
										this.petrotranz = data.petrotranz
									}								
									this.ready = false
								} else {
									this.$swal(data.status, data.message, data.status)
									this.ready = false
									return
								}
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
								this.ready = false
					})
				}
			},
			veo() {
				if (this.offset==="Delete") {
					let splitter = this.filtered.split("(");
					this.filtered = splitter[0]
					this.model.filter= this.filtered
					this.petrotranz = []
					this.filter_p(this.model.filter)
				}
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/locations/m_location.vue